var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraTorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0933 5.43548V0.5H11.5191V5.43548H14.0933ZM6.40624 8.61094L8.22634 6.79084L4.73629 3.30078L2.91618 5.12089L6.40624 8.61094ZM22.7055 5.12857L20.8854 3.30847L17.3953 6.79852L19.2154 8.61863L22.7055 5.12857ZM4.7275 23.0901L8.21756 19.6L6.39745 17.7799L2.9074 21.27L4.7275 23.0901ZM5.43548 14.8806V12.3064H0.5V14.8806H5.43548ZM25.1129 12.3064H20.1774V14.8806H25.1129V12.3064ZM22.6967 21.2779L19.2067 17.7879L17.3865 19.608L20.8766 23.0981L22.6967 21.2779ZM14.0933 25.8999V20.9645H11.5191V25.8999H14.0933ZM7.58365 13.5935C7.58365 16.4673 9.93244 18.8161 12.8062 18.8161C15.68 18.8161 18.0288 16.4673 18.0288 13.5935C18.0288 10.7198 15.68 8.37096 12.8062 8.37096C9.93244 8.37096 7.58365 10.7198 7.58365 13.5935ZM10.1578 13.5935C10.1578 12.1383 11.351 10.9452 12.8062 10.9452C14.2615 10.9452 15.4546 12.1383 15.4546 13.5935C15.4546 15.0488 14.2615 16.2419 12.8062 16.2419C11.351 16.2419 10.1578 15.0488 10.1578 13.5935Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraTorch);
export default __webpack_public_path__ + "static/media/camera-torch.b21179886bdbb2377804e0b3f41a8af7.svg";
export { ForwardRef as ReactComponent };